import { render, staticRenderFns } from "./AccountPC.vue?vue&type=template&id=3df226c4&"
import script from "./AccountPC.vue?vue&type=script&lang=js&"
export * from "./AccountPC.vue?vue&type=script&lang=js&"
import style0 from "./AccountPC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccountPC.vue"
export default component.exports